export const NOTIFICATION_TYPES_MAPPING = {
  CONVERSATION_MENTION: ['i-lucide-at-sign', 'text-n-blue-11'],
  CONVERSATION_ASSIGNMENT: ['i-lucide-chevrons-right', 'text-n-blue-11'],
  CONVERSATION_CREATION: ['i-lucide-mail-plus', 'text-n-blue-11'],
  PARTICIPATING_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-plus',
    'text-n-blue-11',
  ],
  ASSIGNED_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-plus',
    'text-n-blue-11',
  ],
  SLA_MISSED_FIRST_RESPONSE: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  SLA_MISSED_NEXT_RESPONSE: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  SLA_MISSED_RESOLUTION: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  VINCTO_ACTIVITY_REMINDER: ['i-lucide-calendar-clock', 'text-n-amber-11'],
  VINCTO_GOOGLE_CALENDAR_RECONNECT: [
    'i-lucide-calendar-x-2',
    'text-n-amber-11',
  ],
  VINCTO_GOOGLE_CALENDAR_APPOINTMENT_CANCELLED: [
    'i-lucide-calendar-x',
    'text-n-ruby-11',
  ],
  INTERNAL_CHAT_MENTION: ['i-lucide-at-sign', 'text-n-iris-11'],
  INTERNAL_CHAT_NEW_MESSAGE: ['i-lucide-messages-square', 'text-n-iris-11'],
};

// Notificacao de reconexao do Google Agenda: a conexao de profissional se
// reconecta na aba Profissionais; a do usuario, no cabecalho da Agenda.
export const googleCalendarReconnectRoute = practitionerId =>
  practitionerId
    ? {
        name: 'settings_appointments',
        query: { tab: 'practitioners', practitioner_id: practitionerId },
      }
    : { name: 'crm_calendar' };
